import { createAction, props } from '@ngrx/store';

export const updateUWApprovalIsLoadingFromUWApprovalSavingData = createAction(
  '[UWApprovalSavingData] Update UWApproval Is Loading',
  props<{ isLoading: boolean }>()
);